module.exports = __webpack_public_path__ + "img/background.e9174262.jpg";